import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AM_BASE_URL,
  timeout: 10000000,
});

export function setAmAuthTokenOnAxiosInstance(token) {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
